import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginator,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { GrupoRede, GrupoRedeFilter } from '../models';
import { AdmRedePostosService } from '../services/adm-rede-postos.service';

/**
 * Component for filtering entity groups
 */
@Component({
  selector: 'app-filtrar-grupo-entidade',
  templateUrl: './filtrar-grupo-entidade.component.html',
  styleUrls: ['./filtrar-grupo-entidade.component.scss'],
  standalone: true,
  imports: [
    MatSpinnerOverlayComponent,
    MatIconModule,
    MatGridListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatPaginatorModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    CommonModule,
    FormsModule,
    MatTooltipModule,
    MatDialogModule,
  ],
})
export class FiltrarGrupoEntidadeComponent implements AfterViewInit {
  // ==================== Dependencies ====================
  private readonly service = inject(AdmRedePostosService);
  private readonly dialogRef = inject(MatDialogRef<FiltrarGrupoEntidadeComponent>);
  private readonly data = inject<string>(MAT_DIALOG_DATA, { optional: true });

  // ==================== ViewChild ====================
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  // ==================== State ====================
  public loading: boolean = false;
  public grupoSelecionado!: GrupoRede;
  private itemsSemFiltro: GrupoRede[] = [];

  // ==================== Data Source ====================
  readonly items = new MatTableDataSource<GrupoRede>([]);
  readonly displayedColumns = ['codigoGrupo', 'descricaoGrupo'];

  // ==================== Filter Options ====================
  readonly selectUm = [
    { value: 1, viewValue: 'Por Código' },
    { value: 2, viewValue: 'Por Descrição do Grupo' },
  ];

  readonly selectDois = [
    { value: 1, viewValue: 'Igual a' },
    { value: 2, viewValue: 'Maior que' },
    { value: 3, viewValue: 'Menor que' },
    { value: 4, viewValue: 'Contendo' },
    { value: 5, viewValue: 'Iniciando por' },
  ];

  // ==================== Filter (mutable) ====================
  filtro = {
    coluna: this.selectUm[this.data && !isNaN(Number(this.data)) ? 0 : 1].value,
    operador: this.selectDois[this.data && !isNaN(Number(this.data)) ? 0 : 3].value,
    parametro: this.data || '',
  };

  // ==================== Lifecycle ====================
  constructor() {
    this.loadGruposEntidades();
  }

  ngAfterViewInit(): void {
    this.items.paginator = this.paginator;
    this.items.sort = this.sort;
  }

  // ==================== Data Loading ====================
  private loadGruposEntidades(): void {
    this.loading = true;

    const filtroObj = new GrupoRedeFilter(
      this.filtro.coluna,
      this.filtro.operador,
      this.filtro.parametro
    );

    this.service.buscarListaGrupoRede(filtroObj).subscribe({
      next: (grupos) => {
        this.itemsSemFiltro = grupos;
        this.filtrarTabela();
      },
      error: () => {
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  // ==================== Filter Methods ====================
  filtrarTabela(): void {
    switch (this.filtro.coluna) {
      case 1:
        this.filtrarPorCodigo();
        break;
      case 2:
        this.filtrarPorDescricao();
        break;
      default:
        this.items.data = this.itemsSemFiltro;
        break;
    }
  }

  private filtrarPorCodigo(): void {
    this.items.data = this.itemsSemFiltro.filter(
      (item) => item.codigoGrupo === this.filtro.parametro
    );
  }

  private filtrarPorDescricao(): void {
    const parametroLower = this.filtro.parametro.toLowerCase();
    this.items.data = this.itemsSemFiltro.filter((item) =>
      item.descricaoGrupo.toLowerCase().includes(parametroLower)
    );
  }

  limpaFiltro(): void {
    this.filtro.parametro = '';
    this.items.data = this.itemsSemFiltro;
  }

  // ==================== Selection Methods ====================
  gerenciarSelect(grupo: GrupoRede): void {
    this.grupoSelecionado = grupo;
    this.filtro.parametro = grupo.descricaoGrupo;
    this.dialogRef.close(this.grupoSelecionado);
  }
}
